import React from "react";
import {
    ButtonIconCancel,
    ButtonIconDoneEditing,
    convertInputFormToObject,
    SelectField,
    TextField,
    useInputForm
} from "../../Components/Inputs";
import {getCopyStatusTextByValue} from "./libraryUtility";
import {COPY_STATUS_MANUALLY_SET_LIST} from "./libraryConstants";
import {isInSelectList} from "../../Utilities/Types/listUtilities";

interface LibraryItemCopyEditProps {
    copy: Record<string, any>;
    handleCancel: () => void;
    handleDone: (data: Record<string, unknown>) => void;
}

export const LibraryItemCopyEdit = ({
                                        copy,
                                        handleCancel,
                                        handleDone,
                                    }: LibraryItemCopyEditProps) => {

    const copyForm = useInputForm(copy);
    const copyStatus = getCopyStatusTextByValue(copy.status);
    const isUpdatable = isInSelectList(COPY_STATUS_MANUALLY_SET_LIST, copyStatus);

    const handleDoneClick = () => {
        const data = convertInputFormToObject(copyForm);
        handleDone(data);
    }

    return <>
        <tr>
            <td className={`text-center`}>{copy.copyNumber}</td>
            <td>{copy.barCode}</td>
            <td>
                <TextField
                    {...copyForm.shelfLocation}
                    label="shelfLocation"
                    hideLabel
                />
            </td>
            <td>
                {
                    isUpdatable &&
                    <>
                        <SelectField
                            {...copyForm.status}
                            options={COPY_STATUS_MANUALLY_SET_LIST}
                            hideLabel
                        />
                    </>

                }
                {
                    !isUpdatable &&
                    <>{copyStatus}</>

                }
            </td>
            <td className={`action-cell`}>
                <ButtonIconDoneEditing
                    inputDescription={`done editing for copy ${copy.number}`}
                    onClick={handleDoneClick}
                />
                <ButtonIconCancel
                    inputDescription={`cancel editing for copy ${copy.number}`}
                    onClick={handleCancel}
                />
            </td>
        </tr>
    </>;
};
